var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{key:_vm.result.id},[_c('td',[_vm._v(_vm._s(_vm.result.id))]),_c('td',[_vm._v(_vm._s(_vm.result.name))]),_c('td',[_vm._v(_vm._s(_vm.result.status))]),_c('td',[_vm._v(_vm._s(_vm._f("acresFormat")(_vm.result.acres)))]),_c('td',[_vm._v(_vm._s(_vm.result.localityName))]),_c('td',[_c('router-link',{staticClass:"btn btn-secondary btn-sm",attrs:{"to":{ name: 'project', params: {
        project_id: _vm.result.projectId,
        project_id: _vm.result.id }}}},[_vm._v("\n        View\n      ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }